import { motion } from 'framer-motion';
import { BUSINESS_INFO } from '../../constants';
import { dispararConversaoWhatsApp } from '../../utils/gtag';
import './Pricing.scss';

export default function Pricing() {
  const handleWhatsApp = () => {
    dispararConversaoWhatsApp(() => {
      window.open(BUSINESS_INFO.whatsappUrl, '_blank', 'noopener,noreferrer');
    });
  };

  const handleGoogleMaps = () => {
    window.open('https://www.google.com/maps/dir//Av.+%C3%81lvares+Cabral,+894+-+Lourdes,+Belo+Horizonte+-+MG', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="pricing" id="precos">
      <div className="container">
        <motion.div 
          className="pricing-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Preço simples. Serviço rápido.</h2>
          <p className="section-subtitle">Aberto todos os dias das 6h às 23h em Lourdes</p>
        </motion.div>

        <div className="pricing-grid">
          <motion.div 
            className="pricing-card featured"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <div className="pricing-icon">
              <i className="ri-shirt-line"></i>
            </div>
            <h3 className="pricing-title">Autoatendimento</h3>
            <div className="pricing-price">
              <span className="currency">R$</span>
              <span className="amount">16,99</span>
            </div>
            <p className="pricing-description">Lava ou seca</p>
            <ul className="pricing-features">
              <li><i className="ri-check-line"></i> Máquinas de 10kg</li>
              <li><i className="ri-check-line"></i> Produtos premium inclusos</li>
              <li><i className="ri-check-line"></i> Secagem em 45 minutos</li>
              <li><i className="ri-check-line"></i> Wi-Fi grátis</li>
            </ul>
            <button onClick={handleGoogleMaps} className="pricing-btn">
              Ver localização
            </button>
          </motion.div>

          <motion.div 
            className="pricing-card featured"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="pricing-icon">
              <i className="ri-service-line"></i>
            </div>
            <h3 className="pricing-title">Serviço Completo</h3>
            <div className="pricing-price">
              <span className="amount">Lavamos por você</span>
            </div>
            <p className="pricing-description">Lavar, secar e dobrar</p>
            <ul className="pricing-features">
              <li><i className="ri-check-line"></i> Lavagem profissional</li>
              <li><i className="ri-check-line"></i> Secagem e dobragem</li>
              <li><i className="ri-check-line"></i> Passadoria a vapor</li>
              <li><i className="ri-check-line"></i> Atendimento humanizado</li>
              <li><i className="ri-check-line"></i> Edredons e cobertores</li>
            </ul>
            <button onClick={handleWhatsApp} className="pricing-btn">
              Consultar no WhatsApp
            </button>
          </motion.div>

          <motion.div 
            className="pricing-card schedule-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className="pricing-icon">
              <i className="ri-calendar-check-line"></i>
            </div>
            <h3 className="pricing-title">Horário de Funcionamento</h3>
            <div className="schedule-info">
              <div className="schedule-item">
                <i className="ri-time-line"></i>
                <div>
                  <strong>Segunda a Domingo</strong>
                  <p>6h às 23h</p>
                </div>
              </div>
              {/* <div className="schedule-note">
                <i className="ri-information-line"></i>
                <p>Último atendimento: 22:30</p>
              </div> */}
            </div>
            <div className="schedule-highlight">
              <i className="ri-calendar-2-line"></i>
              <span>Aberto todos os dias, incluindo feriados</span>
            </div>
            <div className="schedule-location">
              <i className="ri-map-pin-line"></i>
              <span>No coração do bairro Lourdes – BH</span>
            </div>
            <button onClick={handleGoogleMaps} className="schedule-btn">
              <i className="ri-map-pin-line"></i>
              Quero chegar agora
            </button>
          </motion.div>
        </div>

        <motion.div 
          className="humanized-box"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="humanized-icon">
            <i className="ri-heart-3-line"></i>
          </div>
          <div className="humanized-content">
            <h3>Atendimento Humanizado</h3>
            <p>Atendimento feito com cuidado e atenção aos detalhes. <strong>Não somos apenas máquinas!</strong> Nossa equipe está sempre pronta para ajudar e garantir que suas roupas recebam o melhor tratamento.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}